function initSoftwareDownloads(root) {
    const buttons = root.querySelectorAll('[data-platform-filter]');
    const files = root.querySelectorAll('.swdl_file');
    if (!buttons.length || !files.length) return;

    function applyFilter(slug) {
        files.forEach(file => {
            const platforms = (file.dataset.platforms || '').trim();
            const matches = slug === 'all' || platforms === '' || platforms.split(/\s+/).includes(slug);
            file.classList.toggle('is-hidden', !matches);
        });
        buttons.forEach(btn => {
            btn.classList.toggle('is-active', btn.dataset.platformFilter === slug);
        });
    }

    buttons.forEach(btn => {
        btn.addEventListener('click', () => applyFilter(btn.dataset.platformFilter));
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-software-downloads]').forEach(initSoftwareDownloads);
});
